export default __webpack_public_path__ + "static/media/icon-brand-funnel.3285d0f6.svg";